
export const GET_PAGE_OPERATION_LIST_FOR_VALUE_BY_PARAMS = "/PageOperation/GetPageOperationListForValueByParams"
